import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'languages';
export const languagesActions = makeActions(MODEL_NAME);

export const getAllLanguages = languagesActions.getAll;
export const editLanguages = languagesActions.edit;
export const createLanguages = languagesActions.create;
export const getByIdLanguages = languagesActions.getDataById;
